
















































































import { container } from 'tsyringe';
import { ref, Ref, ComputedRef, onMounted, onActivated, onDeactivated, watch, defineComponent, computed } from '@vue/composition-api';
import ViewContainer from '@/components/ViewContainer.vue';
import Storyblok from '@/views/Storyblok.vue';
import { ModelManager } from '@/prototyping/model';
import { RecordPlayer } from '@/prototyping/model/models/storyblok-audio-lib';

export default defineComponent({
  components: { ViewContainer, Storyblok },
  name: 'Player',
  setup() {
    const isWeb = computed(() => !!process.env.VUE_APP_WEB);
    const spinningPostcard: Ref<HTMLImageElement | null> = ref(null);
    const spinningAnim: Ref<Animation | null> = ref(null);
    const modelManager = container.resolve(ModelManager);
    const audioPlayer = modelManager.get('audio-player', 'AudioPlayerModel');
    const vinylpostcards = modelManager.get('vinylpostcards', 'VinylPostcardsModel');
    const audioLib = modelManager.get('audio-lib', 'StoryblokAudioLibModel');
    const audioInfo = audioLib.getAudioTrackInfo(audioPlayer.currentAudioTrack);
    const currentRecordPlayerIndex: Ref<number> = ref(0);
    const currentRecordPlayer: ComputedRef<RecordPlayer> = computed(
      () => vinylpostcards?.state?.availableRecordPlayers[currentRecordPlayerIndex.value] ?? vinylpostcards.state.recordPlayer
    );
    let isActive = true;

    function overwritePlayerBasedOnState(state: typeof vinylpostcards.state) {
      const recordPlayer = (state?.recordPlayer as RecordPlayer) ?? undefined;
      const recordPlayers = state?.availableRecordPlayers ?? undefined;

      if (recordPlayer && recordPlayers) {
        console.info(`Overwriting played based on state to ${recordPlayer}`);
        currentRecordPlayerIndex.value = recordPlayers.indexOf(recordPlayer);
      }
    }

    function overwriteRecordPlayerBasedOnAudioInfo(info: Required<typeof audioInfo>, state: typeof vinylpostcards.state) {
      if (!info?.value?.recordPlayer || !state) return;

      const recordPlayer: RecordPlayer = info.value.recordPlayer as RecordPlayer;
      const recordPlayers = vinylpostcards.state.availableRecordPlayers;

      console.info(`Change player based on audio to "${recordPlayer}"`);

      if (!recordPlayers.includes(recordPlayer)) {
        console.info(info.value.recordPlayer);
        vinylpostcards.setAvailableRecordPlayers([...recordPlayers, recordPlayer]);
        // set to new player
        currentRecordPlayerIndex.value = recordPlayers.length;
      } else {
        // set to already existing player
        currentRecordPlayerIndex.value = recordPlayers.indexOf(recordPlayer);
      }

      vinylpostcards.changeRecordPlayer(recordPlayer);
    }

    watch(vinylpostcards.state, overwritePlayerBasedOnState);

    onMounted(() => {
      overwritePlayerBasedOnState(vinylpostcards.state);
      overwriteRecordPlayerBasedOnAudioInfo(audioInfo, vinylpostcards.state);

      if (spinningPostcard.value) {
        spinningAnim.value = spinningPostcard.value.animate(
          [
            { transform: 'rotate(0deg)' },
            { transform: 'rotate(90deg)', offset: 0.25 },
            { transform: 'rotate(180deg)', offset: 0.5 },
            { transform: 'rotate(270deg)', offset: 0.75 },
            { transform: 'rotate(360deg)', offset: 1.0 },
          ],
          {
            duration: 1818,
            iterations: Infinity,
          }
        );
        if (!audioPlayer.isPlaying.value) spinningAnim.value.pause();
      }
    });

    function changeRecordPlayer() {
      const recordPlayers = vinylpostcards.state.availableRecordPlayers;
      let index = 0;
      if (currentRecordPlayerIndex.value < recordPlayers.length - 1) {
        index = currentRecordPlayerIndex.value + 1;
      }
      currentRecordPlayerIndex.value = index;
      vinylpostcards.changeRecordPlayer(recordPlayers[index]);
    }

    function toggleSpinningAnimation(play: boolean) {
      if (spinningAnim.value) {
        if (play) spinningAnim.value.play();
        else spinningAnim.value.pause();
      }
    }

    watch(audioPlayer.isPlaying, (val) => {
      if (isActive) toggleSpinningAnimation(val);
    });

    onActivated(() => {
      isActive = true;
      toggleSpinningAnimation(audioPlayer.isPlaying.value);
    });

    onDeactivated(() => {
      isActive = false;
      toggleSpinningAnimation(false);
    });

    return {
      isWeb,
      audioInfo,
      spinningPostcard,
      currentRecordPlayer,
      changeRecordPlayer,
    };
  },
});
